import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportProfile } from '../../types/import';
import { EndpointResponse } from '../../types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type Response = DBImportProfile[];

/** Saved (persisted) import profiles across all import types, as listed by the upload flow. */
export const getPersistedImportProfiles = async (
  scope: RequestScope,
  _params: undefined = undefined,
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>('import_profile', {
      ...requestOptions,
      params: { query: { persist: true } },
    });

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
